module.exports = __webpack_public_path__ + "static/media/6_bon_de_Reconocimiento.002eb8f3.mp3";